import { useNavigate, useSearchParams } from "react-router-dom";
import { ExpensesPage as ExpensesPageView } from "@/components/ExpensesPage";

export function ExpensesListPage() {
  const navigate = useNavigate();
  const [params, setParams] = useSearchParams();
  const card = params.get("card") ?? undefined;
  const tab = params.get("tab") ?? undefined;
  // In the URL so coming back from an expense lands on the same results.
  const q = params.get("q") ?? "";
  // Keyed on the card so following a different card's "View spend" link resets the filter.
  return (
    <ExpensesPageView
      key={`${card ?? "all"}:${tab ?? ""}`}
      initialCardConnectionId={card}
      initialTab={tab}
      onSelect={(id) => navigate(`/expenses/${id}`)}
      searchQuery={q}
      onSearchChange={(next) =>
        setParams(
          (prev) => {
            const updated = new URLSearchParams(prev);
            if (next) updated.set("q", next);
            else updated.delete("q");
            return updated;
          },
          { replace: !!q && !!next },
        )
      }
    />
  );
}
